// import React from "react";
// import "./Overview.css";
// import PromotionChart from "./PromotionChart";
// import PromotionFeatures from "./PromotionFeatures";
// import PromotionFeaturesgroth from "./PromotionFeaturesgroth";

// const Overview = ({
//   title,
//   onNavigate,
//   onGetStarted
// }) => {
//   const handleCreateCampaign = () => {
//     if (onNavigate) {
//       onNavigate('CREATE CAMPAIGN');
//     }
//   };

//   const handleViewAnalytics = () => {
//     if (onNavigate) {
//       onNavigate('ANALYTICS');
//     }
//   };

//   return (
//     <>
//       <section className="promoRoot">
//         <div className="promoContainer" style={{  }}>

//           {/* ----- LEFT SIDE ----- */}
//           <div className="promoLeft">

//             <h1 className="promoTitle">
//               Grow Your Business
//               <br />
//               <span>Faster</span> with Smart
//               <br />
//               Promotions
//             </h1>

//             <p className="promoDesc">
//               Run branding campaigns, generate leads, launch offers,
//               and increase customer engagement through AI-powered
//               marketing tools — all in one place.
//             </p>

//             <div className="promoActions">
//               <button className="btnPrimary" onClick={handleCreateCampaign}>
//                 <i className="fas fa-rocket" style={{ marginRight: 8 }}></i>
//                 Create Campaign →
//               </button>

//               <button className="btnSecondary" onClick={handleViewAnalytics}>
//                 <i className="fas fa-chart-line" style={{ marginRight: 8 }}></i>
//                 View Analytics
//               </button>

//               <button className="btnLearn">
//                 <i className="fas fa-play-circle"></i> Learn More
//               </button>
//             </div>

//             <div className="promoFeatures">
//               <span><i className="fas fa-check-circle"></i> No setup fees</span>
//               <span><i className="fas fa-check-circle"></i> Cancel anytime</span>
//               <span><i className="fas fa-check-circle"></i> AI optimised</span>
//             </div>

//           </div>

//           {/* ----- RIGHT SIDE (card + chart) ----- */}
//           <div className="promoRight">

//             <div className="analyticsCard">

//               <div className="cardHeader">
//                 <div>
//                   <p>AD PERFORMANCE</p>
//                   <h2>+342% Reach</h2>
//                 </div>
//                 <div className="liveBadge">Live</div>
//               </div>

//               {/* Chart component */}
//               <PromotionChart />

//               {/* Floating card */}
//               <div className="floatingCard">
//                 <div className="iconCircle">
//                   <i className="fas fa-arrow-up"></i>
//                 </div>
//                 <div>
//                   <p>Vendor Success</p>
//                   <h4>+120% Orders</h4>
//                 </div>
//               </div>

//             </div>

//           </div>

//         </div>
//       </section>
//       <PromotionFeatures onNavigate={onNavigate} />
//       <PromotionFeaturesgroth
//         onGetStarted={() => onNavigate("PRICING")}
//       />
//     </>
//   );
// };

// export default Overview;



import React, { useState } from "react";
import "./Overview.css";

import PromotionChart from "./PromotionChart";
import PromotionFeatures from "./PromotionFeatures";
import PromotionFeaturesgroth from "./PromotionFeaturesgroth";
import Promotionspricingdetails from "./Promotionspricingdetails";

const Overview = ({
  title,
  onNavigate,
  onGetStarted
}) => {

  const [showPricing, setShowPricing] = useState(false);
  const [selectedFeature, setSelectedFeature] = useState(null);

  const handleCreateCampaign = () => {
    if (onNavigate) {
      onNavigate("CREATE CAMPAIGN");
    }
  };

  const handleViewAnalytics = () => {
    if (onNavigate) {
      onNavigate("ANALYTICS");
    }
  };

  const handleExplore = (feature) => {
    console.log("Feature received in Overview:", feature);

    setSelectedFeature(feature);
    setShowPricing(true);
  };

  return (
    <>
      {showPricing ? (

        <Promotionspricingdetails
          feature={selectedFeature}
          onBack={() => setShowPricing(false)}
        />

      ) : (

        <>
          <section className="promoRoot">
            <div
              className="promoContainer"
            >

              {/* LEFT SIDE */}

              <div className="promoLeft">

                <h1 className="promoTitle">
                  Grow Your Business
                  <br />
                  <span>Faster</span> with Smart
                  <br />
                  Promotions
                </h1>

                <p className="promoDesc">
                  Run branding campaigns, generate leads, launch offers,
                  and increase customer engagement through AI-powered
                  marketing tools — all in one place.
                </p>

                <div className="promoActions">

                  <button
                    className="btnPrimary"
                    onClick={handleCreateCampaign}
                  >
                    <i
                      className="fas fa-rocket"
                      style={{ marginRight: 8 }}
                    ></i>
                    Create Campaign →
                  </button>

                  <button
                    className="btnSecondary"
                    onClick={handleViewAnalytics}
                  >
                    <i
                      className="fas fa-chart-line"
                      style={{ marginRight: 8 }}
                    ></i>
                    View Analytics
                  </button>

                  <button className="btnLearn">
                    <i className="fas fa-play-circle"></i>
                    Learn More
                  </button>

                </div>

                <div className="promoFeatures">
                  <span>
                    <i className="fas fa-check-circle"></i>
                    No setup fees
                  </span>

                  <span>
                    <i className="fas fa-check-circle"></i>
                    Cancel anytime
                  </span>

                  <span>
                    <i className="fas fa-check-circle"></i>
                    AI optimised
                  </span>
                </div>

              </div>

              {/* RIGHT SIDE */}

              <div className="promoRight">

                <div className="analyticsCard">

                  <div className="cardHeader">

                    <div>
                      <p>AD PERFORMANCE</p>
                      <h2>+342% Reach</h2>
                    </div>

                    <div className="liveBadge">
                      Live
                    </div>

                  </div>

                  <PromotionChart />

                  <div className="floatingCard">

                    <div className="iconCircle">
                      <i className="fas fa-arrow-up"></i>
                    </div>

                    <div>
                      <p>Vendor Success</p>
                      <h4>+120% Orders</h4>
                    </div>

                  </div>

                </div>

              </div>

            </div>
          </section>

          <PromotionFeatures
            onExplore={handleExplore}
          />

          <PromotionFeaturesgroth
            onGetStarted={() => onNavigate("PRICING")}
          />
        </>

      )}
    </>
  );
};

export default Overview;